import React, { useState } from 'react';

const CameraPermissionRequest = ({ onGranted, onDenied }) => {
  const [error, setError] = useState(null);
  const [checking, setChecking] = useState(false);

  const requestPermission = async () => {
    setChecking(true);
    setError(null);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      stream.getTracks().forEach(track => track.stop()); // Clean up stream

      localStorage.setItem('cameraPermissionGranted', 'true');
      onGranted?.();
    } catch (err) {
      console.error('Camera permission error:', err);
      setError("We couldn't access your camera. Please allow camera access in your browser settings.");
      localStorage.setItem('cameraPermissionGranted', 'false');
      onDenied?.();
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="camera-permission-wrapper">
      <h2>📷 Camera Access Needed</h2>
      <p>This feature requires access to your camera. Please grant permission to continue.</p>
      <button className="btn btn-primary" onClick={requestPermission} disabled={checking}>
        {checking ? 'Requesting...' : 'Enable Camera'}
      </button>
      {error && <p className="text-danger mt-3">{error}</p>}

      <style jsx>{`
        .camera-permission-wrapper {
          padding: 2rem;
          text-align: center;
          background-color: #1c1c1e;
          color: white;
          border-radius: 10px;
          box-shadow: 0 0 10px rgba(0,0,0,0.4);
          max-width: 420px;
          margin: 4rem auto;
        }
        .btn {
          margin-top: 1rem;
          padding: 0.75rem 1.5rem;
          font-size: 1rem;
        }
      `}</style>
    </div>
  );
};

export default CameraPermissionRequest;
